import request from "@/utils/request";

export function getCycles() {
    return request({
        url: "poll/getdoreh",
        method: "post",
    });
}

export function getRecipients(FSerial, Type2) {
    return request({
        url: "poll/getrecipients",
        method: "post",
        data: { FSerial: FSerial, Type2: Type2 },
    });
}

export function getPoll(FSerial) {

    return request({
        url: "poll/getpoll",
        method: "post",
        data: { FSerial: FSerial },
    });
}

export function savePoll(Srl_Nazar_Cycle, Srl_Student2, Type2,
    Srl_School, Srl_TeacherTitle, Srl_Chart, answers) {
    return request({
        url: "poll/save",
        method: "post",
        data: {
            Srl_Nazar_Cycle: Srl_Nazar_Cycle,
            Srl_Student2: Srl_Student2,
            Type2: Type2,
            Srl_School: Srl_School,
            Srl_TeacherTitle: Srl_TeacherTitle,
            Srl_Chart: Srl_Chart,
            answers: answers
        },
    });
}